import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
} from "@angular/core";
import { MatTooltip } from "@angular/material/tooltip";

/**
 * Tooltip simple harmonisé (mai 2026) : wrappe le contenu projeté dans
 * un matTooltip Material standard (blanc sur noir, sans surcharge custom).
 *
 * Les inputs `title`, `content`, `formula`, `example` sont concaténés en
 * un seul message texte respectant les sauts de ligne. Plus de popup
 * stylisé avec encadrés colorés — alignement avec le reste de l'app.
 */
@Component({
  selector: "vl-help-tip",
  standalone: true,
  imports: [MatTooltip],
  templateUrl: "./help-tip.component.html",
  styleUrl: "./help-tip.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { "[attr.title]": "null" },
})
export class HelpTipComponent {
  title = input<string>();
  content = input<string>();
  formula = input<string>();
  example = input<string>();
  disabled = input(false);
  delay = input(400);
  /** Conservé pour compat — ignoré dans le mode simple matTooltip. */
  minWidth = input(220);

  hasContent = computed(() =>
    !!(this.title() || this.content() || this.formula() || this.example()),
  );

  tooltipText = computed(() => {
    const parts: string[] = [];
    if (this.title()) parts.push(this.title()!);
    if (this.content()) parts.push(this.content()!);
    if (this.formula()) parts.push(this.formula()!);
    if (this.example()) parts.push(this.example()!);
    return parts.join("\n\n");
  });
}
